import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { ReactiveFormRequestHandler } from '../../adapters/reactive-form-builder.adapters';
import type { Form } from '../../interfaces/form.interface';

@Component({
    selector: 'app-reactive-form-actions',
    standalone: false,
    templateUrl: './form-actions.component.html',
    styleUrls: ['./form-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReactiveFormActionsComponent<T> {
    @Input({ required: true }) public form!: Form<T>;
    @Input({ required: true }) public model!: FormGroup;
    @Input() public recordHasAssociatedData = false;
    @Input() public showActionsButtons = true;
    @Input() public request!: ReactiveFormRequestHandler<any>;
    @Input() public getRequest!: ReactiveFormRequestHandler<any>;
    @Input() public resolveDropdownRawValue: ((fieldName: string, value: unknown) => unknown | null) | null = null;
    @Input() public resolveDropdownBackendValue: ((fieldName: string, value: unknown) => unknown | null) | null = null;

    @Output() public goBack = new EventEmitter<void>();
    @Output() public closeDialog = new EventEmitter<void>();
    @Output() public afterSend = new EventEmitter<T>();

    public get shouldShowActions(): boolean {
        return this.form.type <= 4 && this.showActionsButtons;
    }

    public get shouldShowRequestButton(): boolean {
        return this.form.type <= 3;
    }

    public get backButtonLabel(): string {
        return this.form.type < 3 ? 'Volver' : 'Cerrar';
    }

    public onBackButtonClick(): void {
        if (this.form.type < 3) {
            this.goBack.emit();
            return;
        }

        this.closeDialog.emit();
    }
}
